import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { color } from "src/styles/variables";
import { ButtonLink } from "src/react/components/button/button-base";
import AddressPreview from "./address-preview";

export function AddressList({
  addressList = [],
  triggerManualEntry,
  retrieveAddress,
  findAddress,
  searchTerm,
}) {
  return (
    <Wrapper data-recording-sensitive>
      {addressList
        .filter((item) => item.Type !== "Locality")
        .map((item, index) => {
          return (
            <AddressPreview
              key={item.Id}
              item={item}
              onClick={() =>
                item.Type === "Address"
                  ? retrieveAddress(item.Id)
                  : findAddress(searchTerm, item.Id)
              }
            />
          );
        })}
      <ButtonLink
        css={notListedStyles}
        tabIndex={0}
        onClick={triggerManualEntry}
        onKeyPress={triggerManualEntry}
      >
        My address is not listed
      </ButtonLink>
    </Wrapper>
  );
}

AddressList.propTypes = {
  addressList: PropTypes.array,
  retrieveAddress: PropTypes.func.isRequired,
  findAddress: PropTypes.func.isRequired,
  triggerManualEntry: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
};

export default AddressList;

const shadow1 = "rgba(255, 255, 255, 0)";
const shadow2 = "rgba(0, 0, 0, 0.2)";
const shadow3 = "rgba(0, 0, 0, 0)";

const Wrapper = styled.div`
  max-width: 100%;
  max-height: 50vh;
  overflow-y: auto;
  padding: 20px 10px;
  background: linear-gradient(${color.lightGrey} 30%, ${shadow1}),
    linear-gradient(${shadow1}, ${color.lightGrey} 70%) 0 100%,
    radial-gradient(farthest-side at 50% 0, ${shadow2}, ${shadow3}),
    radial-gradient(farthest-side at 50% 100%, ${shadow2}, ${shadow3}) 0 100%;
  background-repeat: no-repeat;
  background-color: ${color.lightGrey};
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
  background-attachment: local, local, scroll, scroll;
`;

const notListedStyles = `
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 14px;
  text-decoration: underline;
`;
